module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "outer-container"
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('compare-city-picker'), _vm._v(" "), _c('compare-picker'), _vm._v(" "), _c('city-picker'), _vm._v(" "), _c('nghd-list'), _vm._v(" "), _c('city-map')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('aesthetics'), _vm._v(" "), _c('flickr2'), _vm._v(" "), _c('flickr3'), _vm._v(" "), _c('instagram'), _vm._v(" "), _c('street-view'), _vm._v(" "), _c('convenience'), _vm._v(" "), _c('liveliness'), _vm._v(" "), _c('safety'), _vm._v(" "), _c('localness')], 1)])]), _vm._v(" "), _c('page-footer'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    Toggle options:\n    "), _c('a', {
    attrs: {
      "onclick": "$('#similarNghds').toggle()"
    }
  }, [_vm._v("Similar Neighborhoods")]), _vm._v(" "), _c('a', {
    attrs: {
      "onclick": "$('#liveliness').toggle(); $('#safety').toggle(); $('#convenience').toggle(); "
    }
  }, [_vm._v("Graphs")]), _vm._v(" "), _c('a', {
    attrs: {
      "onclick": "$('#localness').toggle()"
    }
  }, [_vm._v("Tweets")]), _vm._v(" "), _c('a', {
    attrs: {
      "onclick": "$('#streetview').toggle()"
    }
  }, [_vm._v("Street View")]), _vm._v(" "), _c('a', {
    attrs: {
      "onclick": "$('#aesthetics').toggle()"
    }
  }, [_vm._v("Photos")]), _vm._v(" "), _c('a', {
    attrs: {
      "onclick": "$('#flickr2').toggle()"
    }
  }, [_vm._v("Flickr 2")]), _vm._v(" "), _c('a', {
    attrs: {
      "onclick": "$('#flickr3').toggle()"
    }
  }, [_vm._v("Flickr 3")]), _vm._v(" "), _c('a', {
    attrs: {
      "onclick": "$('#instagram').toggle()"
    }
  }, [_vm._v("Instagram")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05d24760!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 169
// module chunks = 1